import { styled } from "@mui/material";
import Stack from "@mui/material/Stack";

const StyledInputStack = styled(Stack)(({ theme }) => {
  return {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    gap: "clamp(10px, 10% , 10%)",
  };
});

const InputStack = ({ children }) => {
  return (
    <StyledInputStack flexWrap="wrap" direction="row">
      {children}
    </StyledInputStack>
  );
};

export default InputStack;
